// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xCommonLoadingOverlay } from "@guestsupply/App/Handlers/XNG/Common";
import { getNewsList, GetNewsListApiParameter } from "@guestsupply/App/Services/NewsListService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetNewsListApiParameter, any>;

export const setIsLoading: HandlerType = props => {
    props.dispatch(xCommonLoadingOverlay({ key: "add", value: "create_request_quote" }));
};

export const DispatchBeginLoadNewsList: HandlerType = props => {
    props.dispatch({
        type: "xNewsList/BeginLoadLists",
        parameter: props.parameter,
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getNewsList(props.apiParameter);
};

export const DispatchCompleteLoadNewsList: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch({
            type: "xNewsList/CompleteLoadLists",
            parameter: props.parameter,
            collection: props.apiResult.result,
        } as any);
    }
};

export const setLoadingCompleted: HandlerType = props => {
    props.dispatch(xCommonLoadingOverlay({ key: "clear", value: "create_request_quote" }));
};

export const chain = [
    setIsLoading,
    DispatchBeginLoadNewsList,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadNewsList,
    setLoadingCompleted,
];

const loadNewsList = createHandlerChainRunner(chain, "LoadNewsList");
export default loadNewsList;
